import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
`;